module.exports = __webpack_public_path__ + "img/fitt_logo.fbb5e0b9.svg";